var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("h1", { staticClass: "subtitle is-5" }, [
            _vm._v("Administrar organización"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "title is-1" }, [
            _vm._v("Series documentales"),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "button is-outlined is-primary is-fullwidth",
              attrs: {
                to: { name: "organizacionCrearSerieDocumental" },
                exact: "",
              },
            },
            [
              _c("i", { staticClass: "fas fa-plus fa-fw" }),
              _vm._v(" Nueva serie documental\n  "),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.seriesDoc, function (serie, index) {
        return _c(
          "b-collapse",
          {
            key: index,
            staticClass: "card mb-1 is-radiusless",
            attrs: { animation: "slide", open: _vm.openCollapse == index },
            on: {
              open: function ($event) {
                _vm.openCollapse = index
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "trigger",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "card-header is-radiusless",
                          attrs: { role: "button" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-header-title is-flex-direction-column is-align-items-start",
                            },
                            [
                              _c("p", {}, [
                                _vm._v(_vm._s(serie.nombre)),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !serie.abierta,
                                        expression: "!serie.abierta",
                                      },
                                    ],
                                    staticClass: "tag is-black ml-2 is-400",
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-lock" }),
                                    _vm._v(" Cerrada"),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "is-size-7 is-400" }, [
                                _vm._v(
                                  _vm._s(_vm.truncate(serie.descripcion, 100))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-header-icon" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: props.open ? "caret-up" : "caret-down",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "organizacionVerSerieDocumental",
                                      params: { idSerie: serie.id },
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "arrow-alt-circle-right" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          [
            _vm._v(" "),
            _c("div", { staticClass: "card-content is-radiusless" }, [
              _c(
                "nav",
                {
                  staticClass: "breadcrumb has-dot-separator",
                  attrs: { "aria-label": "breadcrumbs" },
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "organizacionVerSerieDocumental",
                                params: { idSerie: serie.id },
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-eye" }),
                            _vm._v(" Ver serie"),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "organizacionEditarSerieDocumental",
                                params: { idSerie: serie.id },
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-edit" }),
                            _vm._v(" Editar serie"),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    serie.abierta
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openConfirmCerrar(serie)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-lock" }),
                              _vm._v(" Cerrar serie"),
                            ]
                          ),
                        ])
                      : _c("li", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openConfirmAbrir(serie)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-lock-open" }),
                              _vm._v(" Abrir serie"),
                            ]
                          ),
                        ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "has-text-danger",
                          on: {
                            click: function ($event) {
                              return _vm.openConfirmDelete(serie)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-trash" }),
                          _vm._v(" Eliminar serie"),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "subtitle is-5" }, [
                _vm._v("Descripción"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  "\n            " + _vm._s(serie.descripcion) + "\n        "
                ),
              ]),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }